/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetRegionsResponseJson } from './get-regions-response-json';
import { GetRegionsResult } from '../results/get-regions-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { RegionDto } from '../models/region-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetRegionsResponse extends ResponseWithErrorGeneric<GetRegionsResponseJson, GetRegionsResult> implements IResponseWithErrorGeneric<GetRegionsResult> {
  public regions: RegionDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetRegionsResponse>) {
    super(response, GetRegionsResult.Error);
    if (this.result !== GetRegionsResult.Success) {
      return;
    }

    this.regions = this.body.regions ? this.body.regions : [];
  }
  //</custom-body>
}
